import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=96d6f7aa&lang=pug&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d6f7aa')) {
      api.createRecord('96d6f7aa', component.options)
    } else {
      api.reload('96d6f7aa', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=96d6f7aa&lang=pug&", function () {
      api.rerender('96d6f7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-header.vue"
export default component.exports